/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import UpperFooterSlider from "../../Layout/Upper Footer Slider/UpperFooterSlider";
import { Link } from "react-router-dom";
import {
  UserPlus,
  BadgeCheck,
  Share2,
  DollarSign,
  ArrowRight,
  Gift,
} from "lucide-react";

export default function AffiliateProgram() {
  return (
    <div className="Gallery-Wraps contact program">
      <main>
        {/* Program section start */}
        <section className="parent">
          <section
            // className=" pb-200 Partener photographs"
            className=" pb-55 Partener photographs"
            // data-background="assets/img/breadcrumb/routing.png"
            style={{
              backgroundSize: "cover",
              backgroundImage: 'url("assets/img/breadcrumb/routing.png")',
            }}
          >
            <div className="container">
              <div className="row ">
                <div className="row text text-center ">
                  <div className="col-xl-12 col-lg-12 col-md-12 text-center mt-20">
                    <h4 className="text-left second">Affiliate Program</h4>
                    <p className="w-50">Welcome to the affiliate center.</p>
                  </div>
                </div>
                <div
                  className="col-xl-12 col-lg-12 col-md-12 text-center m-auto pt-10"
                  style={{ zIndex: 9 }}
                >
                  <div className="image-outer-corner">
                    <img
                      className="w-32"
                      src="assets/img/gallery/Affiliate-image.png"
                      alt=""
                    />
                    <span className="inner-image-text">
                      <div className="row">
                        <div className="col-xl-6 col-lg-6 col-md-12 text-start">
                          <div className="text-contetn-left">
                            Join our affiliate program and start earning money
                            for every sale you send our way! Simply create your
                            account, place your linking code into your website
                            and watch your account balance grow as your visitors
                            become our customers.
                          </div>
                          <Link
                            to="/affiliateProgram/signup"
                            className="banner btn head mt-40"
                          >
                            Join Our Affiliate Program
                            <ArrowRight size={18} className="ms-2" />
                          </Link>
                        </div>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section className="parent">
            {/* <section className=" pt-40 pb-100 Partener photographs">
              <div className="container">
                <div className="row ">
                  <div className="row text text-center mt-10">
                    <div className="col-xl-12 col-lg-12 col-md-12 text-center ">
                      <h4 className="text-left second">How does it work?</h4>
                      <p className="w-50">The process is very simple:</p>
                    </div>
                  </div>
                  <div
                    id="carouselExampleControls"
                    className="carousel slide"
                    data-bs-ride="carousel"
                  >
                    <div className="carousel-inner">
                      <div className="carousel-item">
                        <img
                          src="assets/img/gallery/step-01.png"
                          className="d-block m-auto"
                          alt="..."
                        />
                      </div>
                      <div className="carousel-item">
                        <img
                          src="assets/img/gallery/step-01.png"
                          className="d-block m-auto "
                          alt="..."
                        />
                      </div>
                      <div className="carousel-item active">
                        <img
                          src="assets/img/gallery/step-01.png"
                          className="d-block m-auto"
                          alt="..."
                        />
                      </div>
                    </div>
                    <button
                      className="carousel-control-prev"
                      type="button"
                      data-bs-target="#carouselExampleControls"
                      data-bs-slide="prev"
                    >
                      <span
                        className="carousel-control-prev-icon"
                        aria-hidden="true"
                      />
                      <span className="visually-hidden">Previous</span>
                    </button>
                    <button
                      className="carousel-control-next"
                      type="button"
                      data-bs-target="#carouselExampleControls"
                      data-bs-slide="next"
                    >
                      <span
                        className="carousel-control-next-icon"
                        aria-hidden="true"
                      />
                      <span className="visually-hidden">Next</span>
                    </button>
                  </div>
                  <div className="col-xl-12 col-lg-12 col-md-12 text-center pt-50">
                    <h4 className="text-left second">Already an Affiliate?</h4>
                    <p className="w-50 second-section-a">
                      Please visit the{" "}
                      <span className="highlight-main-color">
                        {" "}
                        Affiliate Login page{" "}
                      </span>{" "}
                      and enter your username and password to gain access to
                      your account statistics, banners, linking code.
                    </p>
                  </div>
                  <div className="text-center mt-60 button-uper">
                    <Link
                      to={"/create-custom-print"}
                      className="large head banner"
                    >
                      Create GALLERY WALL
                    </Link>
                  </div>
                </div>
              </div>
            </section> */}

            <section className="pt-80 pb-80 bg-light">
              <div className="container">
                <div className="row justify-content-center text-center mb-5">
                  <div className="col-lg-8 row text">
                    <h4 className="text-left second">How Does It Work?</h4>

                    <p>
                      Becoming an our affiliate is simple. Follow these
                      four steps to get started.
                    </p>
                  </div>
                </div>

                <div className="row g-4">
                  <div className="col-lg-3 col-md-6">
                    <div className="affiliate-step-card h-100 text-center">
                      {/* <div className="step-number">01</div> */}

                      <div className="affiliate-icon mx-auto mb-3">
                        <UserPlus size={26} />
                      </div>

                      <h5>Apply</h5>

                      <p>
                        Complete our affiliate registration form with your
                        personal, business, promotion, and payment information.
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6">
                    <div className="affiliate-step-card h-100 text-center">
                      {/* <div className="step-number">02</div> */}

                      <div className="affiliate-icon mx-auto mb-3">
                        <BadgeCheck size={26} />
                      </div>

                      <h5>Get Approved</h5>

                      <p>
                        Our team will review your application. Once approved,
                        you will receive your affiliate details by email.
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6">
                    <div className="affiliate-step-card h-100 text-center">
                      {/* <div className="step-number">03</div> */}

                      <div className="affiliate-icon mx-auto mb-3">
                        <Share2 size={26} />
                      </div>

                      <h5>Share Your Link</h5>

                      <p>
                        Share your unique referral link with your audience
                        through your website, social media, or other platforms.
                      </p>
                    </div>
                  </div>

                  <div className="col-lg-3 col-md-6">
                    <div className="affiliate-step-card h-100 text-center">
                      {/* <div className="step-number">04</div> */}

                      <div className="affiliate-icon mx-auto mb-3">
                        <DollarSign size={26} />
                      </div>

                      <h5>Earn Commission</h5>

                      <p>
                        Earn commission on qualifying purchases made by
                        customers referred through your affiliate link.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="text-center mt-40 button-uper">
                <Link
                            to="/affiliateProgram/signup"
                            className="banner btn head"
                          >
                            Join Our Affiliate Program
                            <ArrowRight size={18} className="ms-2" />
                          </Link>
                          </div>
              </div>
            </section>
          </section>

          {/* Why Join */}
          <section className="pt-80 pb-80">
            <div className="container">
              <div className="row justify-content-center text-center mb-5">
                <div className="col-lg-8 row text">
                  <h4 className="text-left second">Why Join Our Affiliate Program?</h4>

                  <p>
                    Turn your audience, network, or online presence into an
                    opportunity to earn with printlific.
                  </p>
                </div>
              </div>

              <div className="row g-4">
                <div className="col-lg-3 col-md-6">
                  <div className="affiliate-feature-card h-100 text-center">
                    <div className="affiliate-icon mb-3 mx-auto">
                      <DollarSign size={26} />
                    </div>

                    <h5>Earn Commission</h5>

                    <p>
                      Earn a percentage of qualifying sales generated through
                      your referral.
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6">
                  <div className="affiliate-feature-card h-100 text-center">
                    <div className="affiliate-icon mb-3 mx-auto">
                      <BadgeCheck size={26} />
                    </div>

                    <h5>Higher Rewards</h5>

                    <p>
                      Bring more customers and unlock higher commission tiers.
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6">
                  <div className="affiliate-feature-card h-100 text-center">
                    <div className="affiliate-icon mb-3 mx-auto">
                      <Share2 size={26} />
                    </div>

                    <h5>Easy to Share</h5>

                    <p>
                      Get your unique referral link and share it across your
                      website, social media, or other platforms.
                    </p>
                  </div>
                </div>

                <div className="col-lg-3 col-md-6">
                  <div className="affiliate-feature-card h-100 text-center">
                    <div className="affiliate-icon mb-3 mx-auto">
                      <Gift size={26} />
                    </div>

                    <h5>Customer Benefits</h5>

                    <p>
                      Referred new customers receive a 10% discount on their
                      first order.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </section>
 
        </section>

        <UpperFooterSlider />
      </main>
    </div>
  );
}
